import {
  GOHIGHLEVEL_INTEGRATION,
  HUBSPOT_INTEGRATION,
  PIPEDRIVE_INTEGRATION,
  SALESFORCE_INTEGRATION,
  ZOHO_INTEGRATION
} from 'src/constants/integrations'

// Which CRM a list was imported from, keyed by the contact_lists.source values in api-core. Manual and CSV have none.
export const INTEGRATION_BY_SOURCE = Object.freeze({
  3: HUBSPOT_INTEGRATION,
  4: PIPEDRIVE_INTEGRATION,
  5: ZOHO_INTEGRATION,
  6: SALESFORCE_INTEGRATION,
  7: GOHIGHLEVEL_INTEGRATION
})
